export default "__VITE_ASSET__C8Jn67Ti__";